export default __webpack_public_path__ + "static/media/1080.c7212e07.png";